import { InputAdornment, Tooltip } from '@mui/material';

export const InputErrorIcon = ({
  errorMessage,
}: {
  errorMessage?: React.ReactNode;
}) => {
  return (
    <InputAdornment position='start'>
      <Tooltip
        slotProps={{
          tooltip: {
            sx: {
              backgroundColor: 'var(--mui-palette-error-main)',
            },
          },
        }}
        title={errorMessage || 'Invalid input'}
      >
        <i className='material-symbols-error-outline-rounded bg-[var(--mui-palette-error-main)]' />
      </Tooltip>
    </InputAdornment>
  );
};
